var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',[_c('Form',{ref:"form",on:{"submitedData":_vm.submitedData}}),_c('br')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }